'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Scribd';

var EntypoScribd = function EntypoScribd(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M4.643,18.284c0,0.224-0.072,0.492-0.148,0.716h5.737c0.328-0.377,0.513-0.831,0.513-1.342c0-1.385-1.644-2.154-5.241-3.842L4.998,13.58C3.225,12.737,1.912,11.995,1,11.111v4.398c0.176-0.024,0.359-0.042,0.558-0.042C4.559,15.468,4.643,18.256,4.643,18.284z M17,1h-3.738c1.748,1.178,2.467,2.842,2.467,4.142c0,2.194-1.836,2.905-2.727,2.905l-0.271,0.002c-2.046,0-3.09-1.247-3.104-3.707C9.506,4.246,8.939,3.889,7.28,3.889c-1.96,0-2.773,1.543-2.773,2.369c0,0.973,0.543,2.055,4.484,3.382c6.736,2.254,6.736,5.255,6.736,7.903v0.026c0,0.437-0.031,0.924-0.117,1.431H17c1.1,0,2-0.899,2-2V3C19,1.9,18.1,1,17,1z' })
    );
};

exports.default = EntypoScribd;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo/lib/entypo/Scribd.js
// module id = ./node_modules/react-entypo/lib/entypo/Scribd.js
// module chunks = 2